if (!customElements.get('shirt-artwork')) {
  customElements.define('shirt-artwork', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.closest('form');
      this.file = this.querySelector('[data-artwork-file]');
      this.delivery = this.querySelector('[data-artwork-delivery]');
      this.status = this.querySelector('[data-artwork-status]');
      this.preview = this.querySelector('[data-artwork-preview]');
      this.onSubmit = (event) => {
        this.validateFile();
        if (!this.form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.form.addEventListener('submit', this.onSubmit, true);
      this.delivery.addEventListener('change', () => this.updateDelivery());
      this.file.addEventListener('change', () => this.updateFile());
      this.updateDelivery();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.releasePreview();
      this.initialized = false;
    }

    updateDelivery() {
      const uploading = this.delivery.value === 'Upload with order';
      this.file.disabled = !uploading;
      this.file.required = uploading;
      this.querySelector('[data-artwork-upload]').hidden = !uploading;
      this.querySelector('[data-artwork-email]').hidden = uploading;
      if (!uploading) {
        this.file.value = '';
        this.updateFile();
      }
    }

    validateFile() {
      const file = this.file.files[0];
      let error = '';
      if (!this.file.disabled && file) {
        if (!/\.(png|jpe?g|pdf)$/i.test(file.name)) error = this.dataset.fileError;
        else if (file.size > 20 * 1024 * 1024) error = this.dataset.sizeError;
      }
      this.file.setCustomValidity(error);
      return !error;
    }

    updateFile() {
      this.releasePreview();
      const file = this.file.files[0];
      const valid = this.validateFile();
      this.status.textContent = valid ? (file?.name || '') : this.file.validationMessage;
      if (valid && file && /\.(png|jpe?g)$/i.test(file.name)) {
        this.previewUrl = URL.createObjectURL(file);
        this.preview.src = this.previewUrl;
        this.preview.hidden = false;
      }
    }

    releasePreview() {
      if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
      this.previewUrl = null;
      this.preview.hidden = true;
      this.preview.removeAttribute('src');
    }
  });
}
